import { ProductTileFeature } from "@omni/types/api/product/bff/shared/productTileFeature.model";
import { cn } from "@omni/utils/styles";

import { renderFeature } from "./description.helpers";

export type ProductTileDescriptionProps = {
    items?: ProductTileFeature[];
    showItems: boolean;
    amountOfFeatures: number;
    className?: string;
};

const ProductTileDescription = ({
    items,
    showItems,
    amountOfFeatures,
    className
}: ProductTileDescriptionProps) => {
    if (!items?.length || !amountOfFeatures || !showItems) return;

    const visibleFeatures = items.slice(0, amountOfFeatures);

    return (
        <div className={cn(className)}>
            <ul className={cn("tw:text-sm tw:mb-0 tw:pl-0")}>
                {visibleFeatures.map((feature, key) => (
                    <li
                        key={key}
                        className={cn(
                            "tw:w-full tw:pb-px tw:overflow-y-hidden tw:truncate"
                        )}
                    >
                        <span className={cn("tw:pr-2 tw:text-primary")}>
                            &#x25A0;
                        </span>
                        {feature.name}:{" "}
                        {renderFeature({
                            formattedValues: feature.featureValues.map(
                                (f) => f.formattedValue || ""
                            ),
                            unitName: feature.unit?.name || null
                        })}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export { ProductTileDescription };
